// firebase.initializeApp(yourConfig);
import { Geolocation, Geoposition, GeolocationOptions } from '@ionic-native/geolocation';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FOGO } from './dadosFogo';
import { AngularFirestore } from '@angular/fire/firestore';
import { Platform } from 'ionic-angular';


/** 
{
  accuracy: 1177
  altitude: null
  altitudeAccuracy: null
  heading: null
  latitude: -20.838703
  longitude: -49.416115
  speed: null
}
**/
@Injectable()
export class LocationProvider {
  public dadosFogo: any = FOGO;

  constructor(private geolocation: Geolocation,
    private platform:Platform,
    private _afs:AngularFirestore) {
    // geo = geofirex.init(firebase);
    // points: Observable<any>;
  }

  /**
   * Buscar os pontos que os usuarios colocaram
   */
  buscaPontos(lat:number, log: number) {
    this._afs.collection("pontos").snapshotChanges();
  }

  public getLocationObservable(): Observable<Geoposition> {
    if(this.platform.is("cordova")) {
      let geoOption: GeolocationOptions = {
        enableHighAccuracy:true,
        
      }
    }
    let watch = this.geolocation.watchPosition();
    
    // let getPostion = this.geolocation.getCurrentPosition();

    watch.subscribe((data) => {
      // data can be a set of coordinates, or an error (if an error occurred).
      // data.coords.latitude
      // data.coords.longitude
      console.log(data);
    });
    return watch;
  }


  public getPontosDeIncendio() {
    this.dadosFogo.events.filter(cada => cada.categories.filter(eita => eita.title.indexOf("Wildfires") != -1).length).map(cada => cada.geometries[0].coordinates).sort();
  }

}



// WEBPACK FOOTER //
// ./src/providers/location/location.ts